import {useMemo} from 'react';

export function useQueryString<T>(): T {
  return useMemo(
    () => {
      return Object.fromEntries(new URLSearchParams(window.location.search)) as unknown as T;
    },
    [window.location.href]
  );
}
